<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('chaperones')"
                        :isNewButton="checkPermission('chaperone_store')"
                        :isColumns="true"
                        @new-button-click="createFormShow"
                        @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key"
                                             :value="false" :unchecked-value="true"
                                             v-model="column.hidden"
                                             v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('chaperones')"
                              :isNewButton="checkPermission('chaperone_store')"
                              :isColumns="true"
                              @new-button-click="createFormShow"
                              @filter-div-status="datatable.filterStatus = $event">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-mobile-' + key" :name="'checkbox-mobile-' + key"
                                             :value="false" :unchecked-value="true"
                                             v-model="column.hidden"
                                             v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>

            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear">
                <b-row>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="datatable.queryParams.filter.name"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('surname')">
                            <b-form-input v-model="datatable.queryParams.filter.surname"/>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" md="4">
                        <b-form-group :label="$t('email')">
                            <b-form-input v-model="datatable.queryParams.filter.email"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </datatable-filter>

            <datatable :isLoading.sync="datatable.isLoading"
                       :columns="datatable.columns"
                       :rows="datatable.rows"
                       :total="datatable.total"
                       :queryParams="datatable.queryParams"
                       @on-page-change="onPageChange"
                       @on-sort-change="onSortChange"
                       @on-per-page-change="onPerPageChange"
                       v-show="datatable.showTable"/>

            <CommonModal ref="createFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('new').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <create-form @createFormSuccess="createFormSuccess" v-if="formProcess == 'create'"/>
                </template>
            </CommonModal>

            <CommonModal ref="updateFormModal" size="lg" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('edit').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <update-form :formId="formId" @updateFormSuccess="updateFormSuccess"
                                 v-if="formProcess == 'update'"/>
                </template>
            </CommonModal>

            <CommonModal ref="photoModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="photoModalClear">
                <template v-slot:CommonModalTitle>
                    {{ $t('upload_photo').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <div v-if="formProcess == 'photo'">
                        <div class="text-center mb-3" v-if="photoSrc">
                            <b-img :src="photoSrc" fluid rounded style="max-height: 200px;"/>
                        </div>
                        <b-form-group :label="$t('photo')">
                            <b-form-file
                                v-model="photoFile"
                                accept="image/jpg, image/jpeg, image/png"
                                :placeholder="$t('select_file')"
                            />
                        </b-form-group>
                        <div class="text-center mt-3" v-if="photoFilePreview">
                            <b-img :src="photoFilePreview" fluid rounded style="max-height: 200px;"/>
                        </div>
                        <div class="d-flex justify-content-center mt-3">
                            <b-button variant="primary" @click="uploadPhoto" :disabled="!photoFile || photoLoading">
                                {{ $t('upload') }}
                            </b-button>
                        </div>
                    </div>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from '@/layouts/AppLayout';
import Header from '@/layouts/AppLayout/Header';
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';
import DatatableFilter from '@/components/datatable/DatatableFilter';
import Datatable from '@/components/datatable/Datatable';
import CommonModal from '@/components/elements/CommonModal';
import CreateForm from './CreateForm';
import UpdateForm from './UpdateForm';
import ChaperoneService from '@/services/ChaperoneService';
import qs from 'qs';

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,
        CommonModal,
        CreateForm,
        UpdateForm
    },
    metaInfo() {
        return {
            title: this.$t('chaperones')
        }
    },
    data() {
        return {
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: '',
                        field: 'buttons',
                        html: true,
                        sortable: false,
                        tdClass: 'p-0 text-center w-40 align-middle',
                        buttons: [
                            {
                                text: this.$t('edit'),
                                class: 'ri-search-eye-line align-middle top-minus-1 mr-3 text-muted',
                                permission: 'chaperone_update',
                                callback: (row) => {
                                    this.updateFormShow(row.id);
                                }
                            },
                            {
                                text: this.$t('upload_photo'),
                                class: 'ri-image-line align-middle top-minus-1 mr-3 text-muted',
                                permission: 'chaperone_update',
                                callback: (row) => {
                                    this.photoModalShow(row.id);
                                }
                            },
                            {
                                text: this.$t('delete'),
                                class: 'ri-delete-bin-7-line align-middle top-minus-1 mr-3 text-muted',
                                permission: 'chaperone_delete',
                                callback: (row) => {
                                    this.formDelete(row.id);
                                }
                            }
                        ]
                    },
                    {
                        label: this.toUpperCase('id'),
                        field: 'id',
                        hidden: true
                    },
                    {
                        label: this.toUpperCase('name'),
                        field: 'name',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('surname'),
                        field: 'surname',
                        hidden: false
                    },
                    {
                        label: this.toUpperCase('email'),
                        field: 'email',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('mobile_number'),
                        field: 'mobile_tel',
                        hidden: false,
                        sortable: false
                    },
                    {
                        label: this.toUpperCase('birthdate'),
                        field: 'birthdate',
                        hidden: false,
                        sortable: false
                    }
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: 'name',
                    page: 1,
                    limit: 20
                }
            },
            formProcess: null,
            formId: null,
            photoFile: null,
            photoFilePreview: null,
            photoSrc: null,
            photoLoading: false
        }
    },
    watch: {
        photoFile(newVal) {
            if (newVal) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.photoFilePreview = e.target.result;
                };
                reader.readAsDataURL(newVal);
            } else {
                this.photoFilePreview = null;
            }
        }
    },
    created() {
        this.filterSet();
        this.formClear();
    },
    methods: {
        filterSet() {
            this.datatable.queryParams.filter = {
                name: null,
                surname: null,
                email: null
            };
        },
        filterClear() {
            this.filterSet();
            this.getRows();
        },
        filter() {
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == 'desc' ? '-' : '';
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: { ...this.datatable.queryParams },
                paramsSerializer: (params) => qs.stringify(params, { encode: false })
            };

            return ChaperoneService.getAll(config)
                .then(response => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        formClear() {
            this.formId = null;
            this.formProcess = null;
        },
        photoModalShow(id) {
            this.formId = id;
            this.formProcess = 'photo';
            this.photoFile = null;
            this.photoFilePreview = null;
            this.photoSrc = null;
            ChaperoneService.getPhoto(id)
                .then(response => {
                    const blob = new Blob([response.data], { type: 'image/jpeg' });
                    this.photoSrc = URL.createObjectURL(blob);
                })
                .catch(() => {
                    this.photoSrc = null;
                });
            this.$refs.photoModal.$refs.commonModal.show();
        },
        photoModalClear() {
            this.formId = null;
            this.formProcess = null;
            this.photoFile = null;
            this.photoFilePreview = null;
            this.photoSrc = null;
        },
        uploadPhoto() {
            if (!this.photoFile) return;
            this.photoLoading = true;
            const formData = new FormData();
            formData.append('photo', this.photoFile);
            ChaperoneService.uploadPhoto(this.formId, formData)
                .then(response => {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.$refs.photoModal.$refs.commonModal.hide();
                    this.photoModalClear();
                })
                .catch(e => {
                    this.showErrors(e);
                })
                .finally(() => {
                    this.photoLoading = false;
                });
        },
        createFormShow() {
            this.formId = null;
            this.formProcess = 'create';
            this.$refs.createFormModal.$refs.commonModal.show();
        },
        createFormSuccess() {
            this.$refs.createFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },
        updateFormShow(id) {
            this.formId = id;
            this.formProcess = 'update';
            this.$refs.updateFormModal.$refs.commonModal.show();
        },
        updateFormSuccess() {
            this.$refs.updateFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },
        formDelete(id) {
            this.$swal.fire({
                text: this.$t('are_you_sure_to_delete'),
                showCancelButton: true,
                confirmButtonText: this.$t('yes'),
                cancelButtonText: this.$t('no')
            }).then(result => {
                if (result.isConfirmed) {
                    ChaperoneService.del(id)
                        .then(response => {
                            this.$toast.success(this.$t('api.' + response.data.message));
                            this.getRows();
                            this.formClear();
                        })
                        .catch(error => {
                            this.$toast.error(this.$t('api.' + error.data.message));
                        });
                }
            });
        }
    }
}
</script>
